import React from 'react'
import Footer from './Footer'

const ComboPack = () => {
  return (
    <>
      <h3 className='text-center'>Combo Pack Here!</h3>
      <Footer/>
    </>
  )
}

export default ComboPack
